import axiosClient, { ResponseSuccess, ResponseSuccessTotal, ResponseSuccessTotalV2 } from "../axiosClient";

export interface DataTypeIssuedCards {
    key: number;
    icon: string;
    stt?: number;
    mt: string;
    name: string;
    ht: string;
    nph: string;
    nhh: string;
    status: number;
    carePolicy?: string;
    addType?: number;
    point?: number;
    permissionMenu?: PermissionMenu
}

export interface IIssuedCards {
    id: number
    name: string
    codeCard: string
    releaseDate: string
    expirationDate: string
    rank: Rank
    status: number
    addType: number
    listCarePolicies: string
    permissionMenu: PermissionMenu
    fields: Field[]
}

export interface Rank {
    title: string
    icon: string
}

export interface PermissionMenu {
    id: number
    menuId: number
    groupPermissionId: number
    access: boolean
    add: boolean
    edit: boolean
    delete: boolean
    upload: boolean
    download: boolean
    share: boolean
    approve: boolean
    delf: boolean
}

export interface Field {
    fieldId: number
    fieldLabel: string
    fieldCode: string
    value: string
    view: boolean
    edit: boolean
}


export interface RankIssuedCards {
    title: string
    icon: string
}
export interface IInfoIssuedCards {
    username: string;
    code: string;
    releaseDate: string;
    expirationDate: string;
    rank: RankId;
    phone: string;
}
interface RankId {
    id: number;
    title: string;
    icon: string;
}

export interface IInfoCardCustomer {
    listCarePolicies: ICarePolicy[];
    listBenefits: ListBenefit2[];
    listBenefitPolicies: ListBenefit2[];
    listCarePoliciesExcludeRank: ListBenefit2[]
    infoCustomer: InfoCustomer3;
    rank: RankDetail;
    point: number
    nextRankInfo: {
        type: number
        nextRankId: number
        nextRankTitle: string
        nextRankIcon: string
        logicOperator: string
        purchase: {
            totalPurchaseAmount: number
            customerTotalPurchaseAmount: number
            remainingAmount: number
            isMet: boolean
            message: string
        }
        service: {
            totalServiceAmount: number
            customerTotalServiceAmount: number
            remainingAmount: number
            isMet: boolean
            message: string
        }
        isHighestRank: boolean
        message: string

        totalAmount: number
        customerTotalAmount: number
        remainingAmount: number

    }
    permissions: IInfoCardPermissions
}


export interface IInfoCardPermissions {
    cusName: IFieldPermission
    carePolicies: IFieldPermission
    releaseDate: IFieldPermission
    cardIssuanceCode: IFieldPermission
    cardIssuanceSource: IFieldPermission
    points: IFieldPermission
    cardIssuanceStatus: IFieldPermission
    expirationDate: IFieldPermission
    rank: IFieldPermission
}

export interface IFieldPermission {
    view: boolean
    edit: boolean
}

export interface ICarePolicy {
    id: number
    code: string
    title: string
    dateStart: string
    dateEnd: string
    brands: string
    cars: string
    benefitPolicies: Array<{
        id: number
        code?: string
        title?: string
        description?: string
    }>
}

export interface RankDetail {
    id: number;
    title: string;
    icon: string;
    description: string;
    price: number;
}

export interface InfoCustomer3 {

    id: number
    codeCard: string
    customerId: number
    rankId: number
    releaseDate: string
    expirationDate: any
    customerCode: string
    customerImage: any
    code: string
    image: any
    username: string
    phone: string
    rankTitle: string
    rankIcon: string
    titleRank: string
    iconRank: string
    title: string
    icon: string


}

export interface InfoCustomer2 {
    status: number;
    timestamp: string;
    customer: Customer2;
    rank: Rank2;
}
export interface Rank2 {
    id: number;
    icon: string;
    title: string;
}
export interface Customer2 {
    username: string;
    image: string;
}
export interface ListBenefit2 {
    id: number
    code: string
    title: string
    benefitPolicyNames: string
    description: string
}

export interface IListRankEdit {
    id: number;
    title: string;
    icon: string;
}

export const getInfoCardCustomer = async (id: number) => {
    const path = "rank/infoCardCustomer"
    const params = {
        id
    }
    const result: ResponseSuccessTotal<IInfoCardCustomer> = await axiosClient.get(
        path, { params }
    );
    return result;
};

export const updateCardIssuance = async (
    id: number, listCarePolicies: number[], releaseDate?: string, expirationDate?: string, rankId?: number,) => {
    const path = "rank/editCardIssuance"
    const params = {
        id, rankId, listCarePolicies, releaseDate, expirationDate
    }
    const result: ResponseSuccess<[]> = await axiosClient.put(
        path, params
    );
    return result;
};

export const getlistRankEdit = async (id: number) => {
    const path = "rank/listRankEdit"
    const params = {
        id
    }
    const result: ResponseSuccessTotal<IListRankEdit[]> = await axiosClient.get(
        path, { params }
    );
    return result;
};

export const getInfoIssuedCards = async (id: number) => {
    const path = "rank/infoIssuedCards"
    const params = {
        id
    }
    const result: ResponseSuccessTotal<IInfoIssuedCards> = await axiosClient.get(
        path, { params }
    );
    return result;
};

export const addCardIssuance = async (listCustommers: number[], listCarePolicies: number[], releaseDate?: string, expirationDate?: string, rankId?: number) => {
    const path = "rank/addCardIssuance"
    const params = {
        listCustommers, listCarePolicies, releaseDate, expirationDate, rankId,
    }
    const result: ResponseSuccess<[]> = await axiosClient.post(
        path, params
    );
    return result;
};

// export const addCardIssuance = async (id: number, rankId: number, code: string) => {
//     const path = "rank/cardIssuance"
//     const params = {
//         id, rankId, code
//     }
//     const result: ResponseSuccess<[]> = await axiosClient.post(
//         path, params
//     );
//     return result;
// };

export const getListIssuedCards = async (limit?: number, pageNumber?: number, lastId?: number, lastCardId?: number, type?: number, rankId?: number, search?: string, unitScopeId?: number, listGroupCustomer?: number[]
) => {
    const path = "rank/listIssuedCards"
    const params = {
        limit, pageNumber, lastId, lastCardId, type, rankId, search, unitScopeId, listGroupCustomer
    }
    const result: ResponseSuccessTotalV2<IIssuedCards[]> = await axiosClient.get(
        path, { params }
    );
    return result;
};


export const updateActiveIssuedCards = async (
    id: number) => {
    const path = "rank/activeIssuedCards"
    const params = {
        id
    }
    const result: ResponseSuccess<[]> = await axiosClient.put(
        path, params
    );
    return result;
};

// export const addRank = async (title: string, price: number, image: File | null, listBenefits: number[]
// ) => {
//     const path = "rank/addRank"
//     const params = {
//         title, price, image, listBenefits
//     }
//     const result: ResponseSuccess<[]> = await axiosClient.post(
//         path, params
//     );
//     return result;
// };